// 결과의 원문은 유지하고 화면에서만 문단·핵심 문장·시기·조언을 구분한다.
(() => {
  if (globalThis.BGREADING) return;
  const themeGroups = {
    rose: [13, 15, 42, 43, 44, 92, 93], ivory: [7, 10, 12, 30, 51],
    burgundy: [1, 2, 3, 18, 37, 38, 39, 40],
    night: [9, 11, 14, 16, 17, 21, 26, 28, 29, 35, 48],
    violet: [4, 5, 6, 31, 32, 33, 41, 45, 50, 94, 95, 96],
    sky: [19, 20, 22, 23, 24, 25, 27, 34, 36, 46, 47, 49, 52]
  };
  const topicThemes = {
    T01: 'rose', T02: 'violet', T03: 'rose', T04: 'rose', T05: 'rose', T06: 'sky',
    T07: 'ivory', T08: 'violet', T09: 'violet', T10: 'violet', T11: 'sky', T12: 'burgundy',
    T13: 'violet', T14: 'rose', T15: 'rose', T16: 'burgundy', T17: 'ivory', T18: 'night',
    T19: 'sky', T20: 'violet', T21: 'ivory', T22: 'sky', L01: 'rose'
  };
  function theme({ no, room = '', topic } = {}) {
    if (topicThemes[topic || no]) return topicThemes[topic || no];
    const numbered = Object.entries(themeGroups).find(([, ids]) => ids.includes(Number(no)));
    if (numbered) return numbered[0];
    if (/배신|바람|위기|갈등/.test(room)) return 'night';
    if (/이별|재회/.test(room)) return 'burgundy';
    if (/결혼|궁합|인연/.test(room)) return 'ivory';
    if (/연애|사랑/.test(room)) return 'rose';
    if (/돈|재물|금전|일|진로|인생|시기|오늘/.test(room)) return 'sky';
    if (/속마음|흔들림|심리|타로|전생/.test(room)) return 'violet';
    return 'night';
  }
  const themeSelector = '.reveal,.verdict,.reading,.rv,.result[data-topic],.result[data-reading-no]';
  function themeScan() {
    const root = document.documentElement.dataset;
    document.querySelectorAll(themeSelector).forEach(node => {
      const value = theme({ no: node.dataset.readingNo ?? root.readingNo, room: node.dataset.readingRoom ?? root.room, topic: node.dataset.topic });
      if (node.dataset.readingTheme !== value) node.dataset.readingTheme = value;
    });
  }
  const escape = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const sentenceEnd = /[.!?。！？][”’"']?(?=\s|$)/g;
  const dates = /\d{4}년(?:\s*(?:1[0-2]|[1-9])월(?:\s*(?:3[01]|[12]\d|[1-9])일)?)?|(?:1[0-2]|[1-9])월(?:\s*(?:3[01]|[12]\d|[1-9])일)?/g;
  const caution = /(?:^|[\s.!?。！？…，,])([^.!?。！？…\n，,]{0,24}(?:하지\s*마세요|하지\s*말고|피하세요|요구하기보다|재촉하지\s*말고))/g;
  const action = /(?:^|[\s.!?。！？…，,])([^.!?。！？…\n，,]{0,24}(?:시작하세요|살펴보세요|확인하세요|기다리세요|챙기세요|정리하세요))/g;

  function paragraphs(text) {
    const parts = [];
    let start = 0, sentences = 0;
    for (const match of text.matchAll(/[.!?。！？][”’"']?(?=\s|$)|\n+/g)) {
      const end = match.index + match[0].length;
      sentences++;
      if (match[0].includes('\n') || (end - start >= 180 && sentences >= 2) || sentences >= 3) {
        parts.push({ start, end }); start = end; sentences = 0;
      }
    }
    if (start < text.length) parts.push({ start, end: text.length });
    return parts;
  }

  function format(value, kind = 'body') {
    const text = String(value ?? '');
    if (!text.trim()) return escape(text);
    const ranges = [];
    const first = [...text.matchAll(sentenceEnd)][0];
    const leadEnd = first ? first.index + first[0].length : text.length;
    // 기존 작성 규칙의 첫 문장은 그 카드의 결론이다. 긴 설명 전체를 굵게 칠하지 않는다.
    if (kind !== 'answer' && leadEnd <= 120 && text.slice(0, leadEnd).trim().length >= 8) ranges.push({ start: 0, end: leadEnd, type: kind === 'advice' ? 'action' : 'key', priority: 1 });
    for (const [pattern, type, priority, limit] of [[dates, 'date', 4, 20], [caution, 'caution', 3, 1], [action, 'action', 2, 1]]) {
      if (kind === 'answer' && type !== 'date') continue;
      let count = 0;
      for (const match of text.matchAll(pattern)) {
        if (type === 'date' && /\d/.test(text[match.index - 1] || '')) continue;
        const words = match[1] ?? match[0];
        const start = match.index + match[0].length - words.trimStart().length;
        ranges.push({ start, end: match.index + match[0].length, type, priority });
        if (++count >= limit) break;
      }
    }
    const blocks = kind === 'answer' ? [{ start: 0, end: text.length }] : paragraphs(text);
    return blocks.map(({ start, end }) => {
      const stops = [...new Set([start, end, ...ranges.flatMap(r => [r.start, r.end]).filter(i => i > start && i < end)])].sort((a, b) => a - b);
      let html = '';
      for (let i = 0; i < stops.length - 1; i++) {
        const a = stops[i], b = stops[i + 1];
        const active = ranges.filter(r => r.start <= a && r.end >= b).sort((x, y) => y.priority - x.priority)[0];
        const words = escape(text.slice(a, b));
        html += active ? `<strong class="bw-reading-${active.type}">${words}</strong>` : words;
      }
      return kind === 'answer' ? html : `<span class="bw-reading-paragraph">${html}</span>`;
    }).join('');
  }

  const selector = [
    '.wrt .ac', '.wrt .alead',
    '.rv-ch .rv-p', '.rv-ch .rv-lead', '.rv-ch .rv-ans',
    // 10/14 보관함 결과지 새 디자인(src/Result.jsx · .rvm) — 무료 풀이 글 · 장마다 풀이 글 · 조언 · 최종 결론
    '.rvm .m-free > .m-lead', '.rvm .m-free > .m-p', '.rvm .m-body > .m-p', '.rvm .m-adv > .m-p', '.rvm .m-end > .m-p',
    '#wAns', '#tarotFull .rl > li > p', '#wAdvP', '#tarotFull .xs > p', '#tarotFull .xi > p',
    'main .all .ch > p', 'main .head > .big'
  ].join(',');
  const seen = new WeakMap();
  function rawText(node) {
    return [...node.childNodes].map(child => child.nodeType === 3 ? child.nodeValue : child.nodeType === 1 && child.tagName === 'BR' ? '\n' : child.nodeType === 1 ? rawText(child) : '').join('');
  }
  function apply(node) {
    if (!node?.matches?.(selector) || node.closest('.wfail, .wskel, .nope, .rv-nope, .rv-person, [role="status"], .fxglow')) return;
    if (node.querySelector('button, a, input, img, svg, .wload')) return;
    const adviceBlock = node.closest('.adv, .rv-adv, .m-adv, #wAdv');
    const kind = adviceBlock || node.id === 'wAdvP' ? 'advice' : node.matches('.alead, .rv-lead, .m-lead, .rv-ans, #wAns, .ans > p, .big, .lead, .pv, #rv-ch-conclusion .rv-p, #rv-ch-conclusion .m-p') ? 'answer' : 'body';
    // 공유 결과의 조언 제목은 보존한다. 본문에 있던 줄바꿈도 원문으로 읽는다.
    const label = kind === 'advice' ? [...node.children].find(child => child.tagName === 'B' && (window.BGLANG?.sourceText(child) ?? child.textContent).trim() === '조언') : null;
    const text = [...node.childNodes].filter(child => child !== label).map(child => child.nodeType === 3 ? child.nodeValue : child.nodeType === 1 && child.tagName === 'BR' ? '\n' : child.nodeType === 1 ? rawText(child) : '').join('');
    if (!text.trim() || seen.get(node)?.text === text && seen.get(node)?.kind === kind && node.querySelector(':scope > .bw-reading-content')) return;
    // 엔진 그래프·명식·재시도·구매 버튼은 대상 밖이다. 본문은 이스케이프 후 그린다.
    const heading = label?.cloneNode(true);
    node.innerHTML = `<span class="bw-reading-content">${format(text, kind)}</span>`;
    if (heading) node.prepend(heading);
    node.classList.add('bw-reading-' + kind);
    if (kind === 'advice') (adviceBlock || node).classList.add('bw-reading-advice-block');
    seen.set(node, { text, kind });
  }
  function scan(root) {
    if (root?.matches?.(selector)) apply(root);
    root?.querySelectorAll?.(selector).forEach(apply);
  }
  globalThis.BGREADING = Object.freeze({ format, paragraphs, scan, theme });
  if (typeof document === 'undefined') return;
  const pending = new Set();
  let frame = 0;
  function queue(node) {
    if (node?.nodeType === 3) node = node.parentElement;
    if (!node?.querySelectorAll) return;
    const owner = node.closest(selector);
    if (owner) pending.add(owner);
    if (node.matches(selector)) pending.add(node);
    node.querySelectorAll(selector).forEach(item => pending.add(item));
    if (!pending.size || frame) return;
    frame = requestAnimationFrame(() => { frame = 0; const nodes = [...pending]; pending.clear(); nodes.filter(n => n.isConnected).forEach(apply); });
  }
  function start() {
    scan(document.body);
    themeScan();
    let themeFrame = 0;
    const observer = new MutationObserver(changes => {
      if (!themeFrame) themeFrame = requestAnimationFrame(() => { themeFrame = 0; themeScan(); });
      for (const change of changes) {
        if (change.type === 'childList') { queue(change.target); change.addedNodes.forEach(queue); }
        else queue(change.target);
      }
    });
    observer.observe(document.documentElement, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'data-room', 'data-reading-no', 'data-reading-room', 'data-topic'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
